<form action="" (submit)="onSubmit($event)">
    <div class="dialog">
        <div class="header">
            <h3 data-cy="no-data-history-window-title" class="title">
                {{ data.title | translate }}
            </h3>
        </div>
        <div class="content">
            <div class="description-container" *ngIf="data.description">
                <p
                    data-cy="no-data-history-window-info-text"
                    class="description"
                >
                    {{ data.description | translate }}
                </p>
            </div>
            <app-textarea
                class="textarea-container"
                *ngIf="data.textareaPlaceholder"
                [value]="data.textareaValue"
                [subTitle]="data.textareaSubTitle"
                [placeholder]="data.textareaPlaceholder"
                [maxlength]="255"
                (changeEventEmitter)="onTextAreaChange($event)"
            />
        </div>
        <div
            class="footer"
            [ngClass]="[data.extensionButtonLeft ? 'button-reverse' : '']"
        >
            <button
                data-cy="no-data-history-cancel-button"
                class="button"
                type="button"
                (click)="onCloseButtonClick()"
                *ngIf="data.closeButtonText"
            >
                {{ data.closeButtonText | translate }}
            </button>
            <button
                class="button"
                type="submit"
                *ngIf="data.extensionButtonText"
            >
                {{ data.extensionButtonText | translate }}
            </button>
        </div>
    </div>
</form>
